(() => {
  'use strict';

  const SELECTOR = '.membership-included';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class MembershipIncluded {
    constructor(section) {
      this.section = section;
      this.leftCol = section.querySelector('[data-mi-left]');
      this.cards = Array.from(section.querySelectorAll('[data-mi-card]'));
      this.observer = null;

      if (!this.cards.length) return;
      this.init();
    }

    init() {
      if (prefersReducedMotion || document.body.classList.contains('animate--none')) {
        this._showAll();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      if (this.leftCol) {
        this.observer.observe(this.leftCol);
      }

      this.cards.forEach((card) => this.observer.observe(card));
    }

    _showAll() {
      if (this.leftCol) this.leftCol.classList.add('is-visible');
      this.cards.forEach((card) => card.classList.add('is-visible'));
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  const initAll = () => {
    document.querySelectorAll(SELECTOR).forEach((section) => {
      if (section.__membershipIncluded) return;
      section.__membershipIncluded = new MembershipIncluded(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const ct = e.target;
    const sec = ct.matches(SELECTOR) ? ct : ct.querySelector(SELECTOR);
    if (!sec || sec.__membershipIncluded) return;
    sec.__membershipIncluded = new MembershipIncluded(sec);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const ct = e.target;
    const sec = ct.matches(SELECTOR) ? ct : ct.querySelector(SELECTOR);
    if (!sec || !sec.__membershipIncluded) return;
    sec.__membershipIncluded.destroy();
    delete sec.__membershipIncluded;
  });
})();
